export interface IBannerConfig {
    dismissble: boolean;
    icon: string;
    style: string;
}

export const AVAILABLE_BANNER_CONFIG: { confirmation: IBannerConfig, error: IBannerConfig, warning: IBannerConfig } = {
    confirmation: { dismissble: true, icon: '#icon-confirm', style: 'skv-banner skv-banner--confirm' },
    error: { dismissble: false, icon: '#icon-error', style: 'skv-banner skv-banner--error' },
    warning: { dismissble: true, icon: '#icon-warning', style: 'skv-banner skv-banner--warning' },
};
